import { useCallback, useEffect, useState } from 'react'
import ProductsApi from 'lib/api/products'
import StateStorage from 'lib/state-storage'

function useSimilarProduct({ productId, limit }) {
  const [similarProducts, setSimilarProducts] = useState([])
  const [meta, setMeta] = useState({
    isFetching: false,
    error: null,
  })

  const fetchSimilarProducts = useCallback(async () => {
    try {
      const shop = StateStorage.getShop()
      const lang = StateStorage.getLanguage()
      setMeta({ isFetching: true })
      const result = await ProductsApi.getSimilarsByProduct({
        productId,
        shop,
        lang,
        limit,
      })
      setSimilarProducts(result)
      setMeta({ isFetching: false })
    } catch (error) {
      setMeta({ isFetching: false, error })
    }
  }, [productId, limit])

  useEffect(() => {
    fetchSimilarProducts()
  }, [fetchSimilarProducts])

  return [similarProducts, meta]
}

export default useSimilarProduct
